import {
  SET_USER,
  SET_BRANDS,
  SET_COMPANY_USERS,
  ADD_NEW_BRAND,
  UPDATE_IFC_BRAND,
  REMOVE_BRAND,
  REMOVE_USER_FROM_BRAND,
  ADD_USER_TO_BRAND,
  SET_STATUSES,
  SET_CATALOGS_TREE,
  SET_CATALOGS,
  UPDATE_STATUS,
  SET_PERM,
  FEATURE_REQUEST,
  SET_SIDEBAR,
  SET_COMPANY_PERMISSION,
  SET_ALL_PERMISSION,
  SET_ALL_HEALTH_REPORT,
  SET_ALL_PARAMETERS,
  SET_COMPANY_SETTINGS,
  UPDATE_BRAND,
  SET_PERSONAL_AREA_ACTIVE_TAB,
  SET_COMPANY_ROLE,
  SET_USER_ANALYTICS,
  REFRESH_BRANDS,
  BRAND_FILES_TREE,
  SET_ADMIN_MOBILE_SIDEBAR,
  RESET_BRAND_ACTIVE_CONTEXT,

  // ADD_NEW_POST
} from '../constants/action-types/user';


// export const addNewPost = (post) => ({
//   type: ADD_NEW_POST,
//   payload: post
// });

// reset brand active context when creating new brand


export const setUser = user => {
  return {
    type: SET_USER,
    payload: user,
  };
};

export const setBrands = brands => {
  return {
    type: SET_BRANDS,
    payload: brands,
  };
};
export const setMilestones = statuses => {
  return {
    type: SET_STATUSES,
    payload: statuses,
  };
};

export const updateMilestone = milestones => {
  return {
    type: UPDATE_STATUS,
    payload: milestones,
  };
};

export const addNewBrand = brand => {
  return {
    type: ADD_NEW_BRAND,
    payload: brand,
  };
};

export const editIfcBrand = brand => {
  return {
    type: UPDATE_IFC_BRAND,
    payload: brand,
  };
};

export const removeBrand = brand => {
  return {
    type: REMOVE_BRAND,
    payload: brand,
  };
};

export const setCompanyUsers = users => {
  return {
    type: SET_COMPANY_USERS,
    payload: users,
  };
};

export const removeUserFromBrand = (user, brand) => {
  return {
    type: REMOVE_USER_FROM_BRAND,
    payload: { user, brand },
  };
};

export const addUserToBrand = (user, brand) => {
  return {
    type: ADD_USER_TO_BRAND,
    payload: { user, brand },
  };
};

export const addPermissionIsUser = (payload) => {
  return {
    type: SET_PERM,
    payload,
  };
};

export const setCompanyPermission = (payload) => {
  return {
    type: SET_COMPANY_PERMISSION,
    payload,
  };
};

export const setAllPermission = (payload) => {
  return {
    type: SET_ALL_PERMISSION,
    payload,
  };
};

export const setFeatureRequest = (payload) => {
  return {
    type: FEATURE_REQUEST,
    payload,
  };
};

export const setSidebarStatus = (payload) => {
  return {
    type: SET_SIDEBAR,
    payload,
  };
};

export const setAdminMobileSidebarStatus = (payload) => {
  return {
    type: SET_ADMIN_MOBILE_SIDEBAR,
    payload,
  };
};

export const setPersonalAreaActiveTab = (payload) => {
  return {
    type: SET_PERSONAL_AREA_ACTIVE_TAB,
    payload,
  };
};

export const setAllHealthReports = (payload) => {
  return {
    type: SET_ALL_HEALTH_REPORT,
    payload,
  };
};

export const setAllParameters = (payload) => {
  return {
    type: SET_ALL_PARAMETERS,
    payload,
  }
}

export const setCatalogsTree = (catalogs) => {
  return {
    type: SET_CATALOGS_TREE,
    payload: catalogs,
  };
};

export const setCatalogs = (catalogs) => {
  return {
    type: SET_CATALOGS,
    payload: catalogs,
  };
}

export const setCompanySettings = (payload) => {
  return {
    type: SET_COMPANY_SETTINGS,
    payload,
  };
}

export const updateBrandData = (payload) => {
  return {
    type: UPDATE_BRAND,
    payload
  }
}

export const setCompanyRole = (payload) => {
  return {
    type: SET_COMPANY_ROLE,
    payload
  }
}

export const setUserAnalytics = (payload) => {
  return {
    type: SET_USER_ANALYTICS,
    payload
  }
}

export const setRefreshBrands = (payload) => {
  return {
    type: REFRESH_BRANDS,
    payload
  }
}

export const setBrandfilesTree = (payload) => {
  return {
    type: BRAND_FILES_TREE,
    payload
  }
  
}